module.exports = __webpack_public_path__ + "static/media/organization-of-citizen-workshops-on-major-social-issues.3770c99a.jpg";